import { Component } from '@angular/core';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule,CommonModule],
  templateUrl: './login.component.html',
})
export class LoginComponent {
  loading = false;
  error = '';

  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService, 
  ) {}

  login() {
    if (this.form.invalid) return;

    this.loading = true;
    this.error = '';

    const { email, password } = this.form.value;
    if (typeof email !== 'string' || typeof password !== 'string') {
      this.error = 'Por favor, complete todos los campos correctamente.';
      this.loading = false;
      return;
    }
    this.authService.login({ email, password }).subscribe({
    
      next: (res) => {
        localStorage.setItem('token', res.token ?? '');
        localStorage.setItem('userId', res.userId !== undefined ? res.userId.toString() : '');
        localStorage.setItem('userName', JSON.stringify(res.nombre));
        localStorage.setItem('email', res.email ?? '');
        localStorage.setItem('debeCambiarPassword', res.debeCambiarPassword ? 'true' : 'false');
         if (res.debeCambiarPassword) {
            this.router.navigate(['/cambiar-password-forzado']);
          } else {
            this.router.navigate(['/dashboard']);
          }
      },
      error: () => {
        this.error = 'Credenciales incorrectas';
        this.loading = false;
      },
    });
  }

  crearCuenta() {
    this.router.navigate(['/registro']);
  }

  recuperarPassword() {
    this.router.navigate(['/recuperar-password']);
  }
}
